import { DatePipe } from "@angular/common";
import { HttpClient } from "@angular/common/http";
import { Component, OnInit, Renderer2, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { DataTableDirective } from "angular-datatables";
import { Subject } from "rxjs";
import { CookieService } from "src/app/core/services/cookie.service";
import { GeneralService } from "src/app/Service/general.service";
import Swal from "sweetalert2";

class DataTablesResponse {
  data: any[];
  draw: number;
  recordsFiltered: number;
  recordsTotal: number;
}

@Component({
  selector: "app-view-epp-list",
  templateUrl: "./view-epp-list.component.html",
  styleUrls: ["./view-epp-list.component.scss"],
})
export class ViewEppListComponent implements OnInit {
  breadCrumbItems: Array<{}>;
  isdropdownShow: boolean;
  isLoading: boolean;

  dtOptions: DataTables.Settings = {};
  dtOptions1: DataTables.Settings = {};
  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  dtTrigger = new Subject<any>();
  submitted = false;
  user: any;
  currentUser: any;
  UserID: any;
  Status: any;
  planId: any;
  constructor(
    private datepipe: DatePipe,
    private gs: GeneralService,
    private router: Router,
    private renderer: Renderer2,
    private http: HttpClient,
    private route: ActivatedRoute,
    private cookie: CookieService
  ) {
    let a = this.router.getCurrentNavigation().extras;
    if (a) {
      if (a.state) {
        this.UserID = a.state.id;
        this.Status = a.state.Status;
        this.planId = a.state["PlanId"];
        console.log("thisuserid", this.UserID);
        console.log("Status", this.Status);
        localStorage.setItem("id", this.UserID);
        localStorage.setItem("Status", this.Status);
      }
    }
    if (localStorage.getItem("Status")) {
      this.Status = localStorage.getItem("Status");
    }
    if (localStorage.getItem("id")) {
      this.UserID = localStorage.getItem("id");
    }
    this.breadCrumbItems = [
      { label: "User Details", path: "/users/users-users-details" },
      { label: "EPP List", path: "/", active: true },
    ];
  }

  ngOnInit() {
    this.getusersbyid();
    this.currentUser = JSON.parse(this.cookie.getCookie("currentUser"));
    this.dtOptions = {
      pagingType: "simple_numbers",
      pageLength: 10,
      serverSide: true,
      processing: true,
      order: [[0, "desc"]],
      ajax: (dataTablesParameters: any, callback) => {
        this.http
          .get<DataTablesResponse>(
            // `${this.gs.getLawyer()}/${dataTablesParameters.search.value != '' ? dataTablesParameters.search.value + '/' : ''}${((dataTablesParameters.start + dataTablesParameters.length) / dataTablesParameters.length)}/${dataTablesParameters.length}`,

            `${this.gs.getEPP()}` +
              `${this.UserID}` +
              `${
                dataTablesParameters.length.value != ""
                  ? "?PageSize=" + dataTablesParameters.length
                  : ""
              }` +
              `&PageNo=${
                (dataTablesParameters.start + dataTablesParameters.length) /
                dataTablesParameters.length
              }` +
              `${
                dataTablesParameters.search.value != ""
                  ? "&search=" + dataTablesParameters.search.value
                  : ""
              }`
          )
          .subscribe((resp: any) => {
            callback({
              recordsTotal: resp.TotalCount,
              recordsFiltered: resp.TotalCount,
              data: resp.data,
            });
            console.log("TP list", resp);
          });
      },
      responsive: true,
      columns: [
        {
          title: "Id",
          data: null,
          render: (data) => {
            return data.userEPPSubscription;
          },
        },
        {
          title: "Entry_Date",
          data: null,
          render: (data) => {
            if (data.entry_date === "0000-00-00" || data.entry_date == null) {
              return "--";
            } else {
              return this.datepipe.transform(data.entry_date, "yyyy-MM-dd");
            }
          },
        },
        {
          title: "Village",
          data: null,
          render: (data) => {
            return data.village ? data.village : "--";
          },
        },
        {
          title: "Taluka",
          data: null,
          render: (data) => {
            return data.taluka ? data.taluka : "--";
          },
        },
        {
          title: "District",
          data: null,
          render: (data) => {
            return data.district ? data.district : "--";
          },
        },
        {
          title: "City Survey Office",
          data: null,
          render: (data) => {
            if (data.BaseDocument === "1") {
              return data.citysurveyoffice;
            } else {
              return "--";
            }
          },
        },
        {
          title: "Ward",
          data: null,
          render: (data) => {
            if (data.BaseDocument === "1") {
              return data.ward;
            } else {
              return "--";
            }
          },
        },
        {
          title: "Survey Number",
          data: "survey_number",
        },
        {
          title: "Start Date",
          data: null,
          render: (data) => {
            return this.datepipe.transform(data.start_date, "MMM, dd yyyy");
          },
        },
        {
          title: "End Date",
          data: null,
          render: (data) => {
            return this.datepipe.transform(data.end_date, "MMM, dd yyyy");
          },
        },
        {
          title: "Status",
          data: null,
          render: (data) => {
            // console.log(data.active);
            if (data.active === 1) {
              return "Active";
            } else {
              return "Inactive";
            }
            // return (data.active = '1' ? 'Active' : 'Inactive');
          },
        },
        {
          title: "Action",
          data: null,
          render(data) {
            // <a title="Edit This Property" class="edit">
            //    <i class="btn font-18 far fa-edit text-secondary" editEppID="${data.userEPPSubscription}"></i></a>

            if (data.active) {
              return `<div style="display:flex">
              <a title="Deactivate This Property" class="delete" >
                  <i
                    class="font-18 mdi mdi-cancel text-secondary"
                    
                    deleteEppID="${data.userEPPSubscription}"
                    isActive="${data.active}"
                  ></i>
                </a></div>
              `;
            } else {
              return ``;
            }
            //   <a title="View This Property">
            //   <i class="btn font-18 far fa-edit text-secondary" editEppID="${data.userEPPSubscription}"></i></a>
            //   <div *ngIf ="${data.active} == 1; then ifBlock; else elseBlock" >
            //  <ng-template #ifBlock>
            //   <a title="View This Property">
            //   <i class="btn font-18 far fa-trash-alt text-secondary" deleteEppID="${data.userEPPSubscription}"></i></a>
            //   </ng-template>
            //   <ng-template #elseBlock>
            //   <a title="View This Property">
            //   <i class="btn font-18 fas fa-recycle   text-secondary" updateEppID="${data.userEPPSubscription}"></i></a>
            //   </ng-template>
            //   </div>
            //   </div>`;
          },
        },
      ],
      drawCallback: () => {
        $(".delete").on("click", (e) => {
          var msg;
          var value;
          if (e.target.getAttribute("isActive") == "1") {
            msg = "You want Deactivate this EPP ?";
            value = "0";
          } else {
            msg = "You want Activate this EPP ?";
            value = "1";
          }
          Swal.fire({
            title: "Are you sure?",
            text: msg,
            type: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes",
            cancelButtonText: "No",
            confirmButtonClass: "btn btn-danger mt-2",
            cancelButtonClass: "btn btn-success ml-2 mt-2",
            buttonsStyling: false,
          }).then((result) => {
            if (result.value) {
              this.isLoading = true;
              const data = {
                UserSubscriptionMainID: e.target.getAttribute("updateTpID"),
                isActive: value,
              };
              this.gs
                .deletbyid(
                  e.target.getAttribute("deleteEppID"),
                  this.currentUser.Id
                )
                .subscribe(
                  (data) => {
                    this.isLoading = false;
                    console.log(this.currentUser.Id);
                    this.rerender();
                    if (data.status === 200) {
                      this.submitted = false;
                      Swal.fire({
                        title: "Epp Deactivated",
                        text: data.message,
                        type: "success",
                      }).then(() => {
                        this.submitted = false;
                        // this.reFresh.emit();
                      });
                    } else {
                      Swal.fire({
                        title: data.error_code,
                        text: data.message,
                        type: "error",
                      });
                    }
                  },
                  (error) => {
                    //Error callback
                    this.isLoading = false;
                    Swal.fire({
                      title: error.status,
                      text: "Internal Server Error",
                      type: "error",
                    });
                  }
                );
              return false;
            } else if (result.dismiss === Swal.DismissReason.cancel) {
              return false;
            }
          });
        });
        $(".update").on("click", (e) => {
          var msg;
          var value;
          if (e.target.getAttribute("isActive") == "1") {
            msg = "You want Deactivate this EPP ?";
            value = "0";
          } else {
            msg = "You want Activate this EPP ?";
            value = "1";
          }
          Swal.fire({
            title: "Are you sure?",
            text: msg,
            type: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes",
            cancelButtonText: "No",
            confirmButtonClass: "btn btn-danger mt-2",
            cancelButtonClass: "btn btn-success ml-2 mt-2",
            buttonsStyling: false,
          }).then((result) => {
            if (result.value) {
              this.isLoading = true;
              const data = {
                UserSubscriptionMainID: e.target.getAttribute("updateTpID"),
                isActive: value,
                district: e.target.getAttribute("district"),
                taluka: e.target.getAttribute("taluka"),
                village: e.target.getAttribute("village"),
                survey_number: e.target.getAttribute("survey_number"),
                UserID: e.target.getAttribute("UserID"),
                BaseDocument: e.target.getAttribute("BaseDocument"),
                citysurveyoffice: e.target.getAttribute("citysurveyoffice"),
                ward: e.target.getAttribute("ward"),
                sheetno: e.target.getAttribute("sheetno"),
              };
              this.gs
                .Inactive(e.target.getAttribute("updateEppID"), data)
                .subscribe(
                  (data) => {
                    this.rerender();
                    this.isLoading = false;
                    if (data.status === 200) {
                      this.submitted = false;
                      Swal.fire({
                        title: "Epp Activated",
                        text: data.message,
                        type: "success",
                      }).then(() => {
                        this.submitted = false;
                      });
                    } else {
                      Swal.fire({
                        text: data.Message,
                        type: "info",
                        timer: 1500,
                      });
                    }
                  },
                  (error) => {
                    //Error callback
                    this.isLoading = false;
                    Swal.fire({
                      title: error.status,
                      text: "Internal Server Error",
                      type: "error",
                    });
                  }
                );
              return false;
            } else if (result.dismiss === Swal.DismissReason.cancel) {
              return false;
            }
          });
        });
      },
    };
  }
  getusersbyid() {
    this.isLoading = true;
    this.gs.getusersbyid(this.UserID).subscribe(
      (res: any) => {
        this.isLoading = false;
        this.user = res.data[0];
        this.user.mobileno = this.user.MobileNo.split(",");
        this.user.email = this.user.EmailID.split(",");
        localStorage.setItem("PlanId", this.planId);
      },
      (error) => {
        this.isLoading = false;
        Swal.fire({
          title: error.status,
          text: "Internal Server Error",
          type: "error",
        });
      }
    );
  }
  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      // Destroy the table first
      dtInstance.destroy();
      // Call the dtTrigger to rerender again
      this.dtTrigger.next();
    });
  }
  ShowMessage() {
    return this.Status === "deactivated";
  }
  ngAfterViewInit() {
    this.dtTrigger.next();
  }
  editEPP() {
    this.router.navigate(["/users/edit-epp"], { state: { Uid: this.UserID } });
  }
  AddEPP() {
    this.router.navigate(["/users/add-epp"], { state: { Uid: this.UserID } });
  }
  ExistEPP() {
    this.router.navigate(["/users/add-new-epp"], {
      state: { Uid: this.UserID },
    });
  }
}
